import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { MFilters } from 'types/filterTypes'
import useUpdateSettings from 'components/UI/Filter/hooks/useUpdateSettings'

const useLimitToReportsTo = (contentName: MFilters.ContentTypes, limitToReportsTo: boolean, options?: string[], heroFilters?: string[]) => {
  const { saveOptions } = useUpdateSettings(contentName)
  const { userInfo } = useSelector((state: MStore.RootState) => state.users)
  const settings = useSelector((state: MStore.RootState) => state.settings)

  const userId = userInfo?._id
  const filterKey: MFilters.FilterKey = `filter-${contentName}`

  const savedOptions = useMemo(() => {
    return settings[filterKey] || {}
  }, [settings, filterKey])

  // Check if limitToReportsTo is on and remove the reportsTo filter from the options if it is
  const [filteredOptions, filteredHeroFilters] = useMemo(() => {
    const filteredOptions = limitToReportsTo ? options?.filter(option => option !== 'reportsTo') : options || []
    const filteredHeroFilters = limitToReportsTo ? heroFilters?.filter(option => option !== 'reportsTo') : heroFilters || []
    return [filteredOptions, filteredHeroFilters]
  }, [limitToReportsTo, options, heroFilters])

  // Add the reportsToMe filter automatically if limitToReports is on
  useEffect(() => {
    const reportsToNotSet = !('reportsTo' in savedOptions) || !savedOptions.reportsTo.includes(`reportsTo-${userId}`)
    if (limitToReportsTo && reportsToNotSet) {
      saveOptions({ ...savedOptions, reportsTo: [`reportsTo-${userId}`] }, { ignoreLargeCompany: true })
    }
  }, [limitToReportsTo, saveOptions, savedOptions, userId])

  return { filteredOptions, filteredHeroFilters }
}

export default useLimitToReportsTo
